import { useApplicationScope } from "../application/application-provider"

/** Access the application-scoped consistency invalidation runtime from React code. */
export function useDataInvalidation() {
  return useApplicationScope().dataInvalidation
}
